import VectorSource from "ol/source/Vector";
import {transformExtent} from "ol/proj";
import {generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper";
import {getBookmarkPresentationsByID, getLayerByName, removeLayer} from "@/helpers/ol/ol-layer-helper";
import {viewFit} from "@/helpers/ol/ol-view";
import toastr from "toastr"
import {fromExtent} from "ol/geom/Polygon";
import VectorLayer from "ol/layer/Vector";
import {Feature} from "ol";
import {getDefaultStyle} from "ol/format/KML";
import {getPrintVectorLayerStyle} from "@/helpers/print/print-scales-helper";
import {zoomToTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";
import {getService3DTileSetByID, zoomToTileLayerByBookmarkPresentationID} from "@/modules/cesium/cesium-service";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {getFilterVectorLayerStyle} from "@/helpers/filter/filter-helper";
import {getWmsExtent} from "@/http/services/http-services-wms";

export function zoomToFeature(feature,  maxZoom = getDefaultZoom(), duration = 1000) {

    const vectorSource = new VectorSource({
        features: generateGeoJsonObjectFromFeature(feature, true)
    })

    const extent = vectorSource.getExtent()

    zoomToExtent(extent,  maxZoom , duration)
}

export function zoomToLayer(bookmarkPresentationID) {
    let extent

    // console.log(bookmarkPresentationID)

    // Temp layer
    if(typeof bookmarkPresentationID === 'string' && bookmarkPresentationID.includes('temporary-')) {
        extent = zoomToTemporaryLayer(bookmarkPresentationID)

    } else {
        bookmarkPresentationID = parseInt(bookmarkPresentationID)
        const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

        // console.log(bookmarkPresentation)

        if(!bookmarkPresentation) {
            return false
        }

        if(bookmarkPresentation.Type === '3DTileSet' && bookmarkPresentation.extent[0] === "") {
            console.log('zoooom')
            zoomToTileLayerByBookmarkPresentationID(bookmarkPresentationID)
            return true
        }


        if (bookmarkPresentation.Type === 'WMS' || bookmarkPresentation.Type === '3DTileSet' || bookmarkPresentation.Type === 'ArcGISMapServer') {

            if(bookmarkPresentation.bbox === '') {
                getWmsExtent(bookmarkPresentation.ID).then((bbox) => {

                    bbox = bbox.split(',')

                    if(bbox[1] > bbox[3]) {
                        const bboxCopy = bbox
                        bbox[1] = bboxCopy[3]
                        bbox[3] = bboxCopy[1]
                    }

                    extent = new transformExtent(bbox, "EPSG:28992", getViewProjectionName())

                    zoomToLayerExtent(extent)
                })

                return false
            } else {
                const bbox = bookmarkPresentation.extent


                if(bbox[1] > bbox[3]) {
                    const bboxCopy = bbox
                    bbox[1] = bboxCopy[3]
                    bbox[3] = bboxCopy[1]
                }

                extent = new transformExtent(bbox, "EPSG:28992", getViewProjectionName())
            }
        } else {
            const layer = getLayerByName(bookmarkPresentationID)
            if (layer.getSource().getExtent()) {
                extent = layer.getSource().getExtent()
            }
        }
    }

    console.log(extent)

    zoomToLayerExtent(extent)

    return true
}

export function zoomToExtent(extent, maxZoom = getDefaultZoom(), duration = 1000) {
    viewFit(extent, undefined, maxZoom, duration, true)
}

export function getDefaultZoom() {
    if(getViewProjectionName() === 'EPSG:28992' || getViewProjectionName() === 'EPSG:31370') {
        return 12
    }
    return 18
}

function zoomToLayerExtent(extent) {
    if(extent) {
        const vectorSource = new VectorSource()
        let newPolygon = fromExtent(extent);
        const feature = new Feature({
            geometry: newPolygon
        })
        vectorSource.addFeature(feature)
        const vectorLayer = new VectorLayer({
            altitudeMode: 'clampToGround',
            name: 'tempLayer',
            source: vectorSource,
            style: getFilterVectorLayerStyle(),
            zIndex: 1000
        })

        window.map.addLayer(vectorLayer)

        setTimeout(() => {
            zoomToExtent(extent)
            setTimeout(() => {
                removeLayer('tempLayer', false)
            }, 2000)
        }, 300)
    } else {
        toastr.warning('Zoomen naar laag is niet mogelijk')
    }
}
